export default () => ({
  flash: null
})
